var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.192 1.144c.012.078.018.156.017.235v13.4l.133-.293c.133-.285.314-.545.534-.767l3.692-3.758a1.364 1.364 0 0 1 1.769-.197 1.375 1.375 0 0 1 .173 2.038l-6.675 6.795a1.319 1.319 0 0 1-1.888.001h-.001L1.27 11.801a1.376 1.376 0 0 1 .134-2.038 1.364 1.364 0 0 1 1.769.197l3.698 3.75c.196.2.36.43.487.68l.18.408V1.454A1.401 1.401 0 0 1 8.66.02a1.338 1.338 0 0 1 1.532 1.124z",
    fill: "#F6B119",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.c1e73c513db1f3ec170ce506149f2858.svg";
export { ForwardRef as ReactComponent };